import PageWrapper from "../components/ui/PageWrapper";
import HeroSection from "../components/home/HeroSection";
import Timeline from "../components/home/Timeline";

export default function HomePage() {
  return (
    <PageWrapper>
      <HeroSection />
      <Timeline />
    </PageWrapper>
  );
}
